import React from "react";

interface Props {
  changeSource?: string;
}

/**
 * Badge indicating where a change record came from.
 *
 * Provenance matters for audit: a snapshot diff is inferred by comparing two
 * collections, whereas an activity-log entry or a git commit is a first-hand
 * record. The colouring keeps that distinction visible — inferred records use
 * the caution family, first-hand ones stay neutral or success.
 */
export default function ChangeSourceBadge({ changeSource }: Props) {
  const base = "inline-block px-2 py-0.5 rounded-full text-xs font-medium border";

  switch (changeSource) {
    case "snapshot_diff":
      return (
        <span
          className={`${base} bg-caution-subtle text-caution-fg border-caution-border`}
          title="Inferred by comparing two collected snapshots, not read from an audit log"
        >
          Detected Change
        </span>
      );
    case "git_commit":
      return (
        <span className={`${base} bg-success-subtle text-success-fg border-success-border`}>
          Git Commit
        </span>
      );
    default:
      // Legacy records have no changeSource and came from the activity log.
      return (
        <span className={`${base} bg-neutral-subtle text-neutral-fg border-neutral-border`}>
          Activity Log
        </span>
      );
  }
}
